// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__iwDVx","left":"StickyBox_left__3YLVw","right":"StickyBox_right__3uhOH"};